import axios from "axios";
import appConfig from "../config/appConfig";
import { verifyPermission } from "../helpers/permission";


export const createEndpoints = (plan, userPermissions) => {
  const endpoints = {
    PRO: {
      list: (page = 1, perPage = 10, search = '')  => `${appConfig.apiDomaine}/my/users?page=${page}&size=${perPage}&search_text=${search}`,
      enableDisable: (userId) => `${appConfig.apiDomaine}/my/users/${userId}/enabled-desabled`,
      logout: `${appConfig.apiDomaine}/logout`,
    },
    MACRO: {
      holding: {
        list: (page = 1, perPage = 10, search = '')  => `${appConfig.apiDomaine}/any/users?page=${page}&size=${perPage}&search_text=${search}`,
        enableDisable: (userId) => `${appConfig.apiDomaine}/any/users/${userId}/enabled-desabled`,
        downloadPdf: `${appConfig.apiDomaine}/any/users/download/pdf`,
        downloadExcel: `${appConfig.apiDomaine}/any/users/download/excel`,
        logout: `${appConfig.apiDomaine}/logout`,
      },
      filial: {
        list: (page = 1, perPage = 10, search = '') => `${appConfig.apiDomaine}/my/users?page=${page}&size=${perPage}&search_text=${search}`,
        enableDisable: (userId) => `${appConfig.apiDomaine}/my/users/${userId}/enabled-desabled`,
        downloadPdf: `${appConfig.apiDomaine}/my/users/download/pdf`,
        downloadExcel: `${appConfig.apiDomaine}/my/users/download/excel`,
        logout: `${appConfig.apiDomaine}/logout`,
      },
    },
    HUB: {
      list: (page = 1, perPage = 10, search = '')  => `${appConfig.apiDomaine}/any/users?page=${page}&size=${perPage}&search_text=${search}`,
      enableDisable: (userId) => `${appConfig.apiDomaine}/any/users/${userId}/enabled-desabled`,
      logout: `${appConfig.apiDomaine}/logout`,
    },
  };

  let endPoint = '';
  switch(plan){
    case 'MACRO':
        if(verifyPermission(userPermissions,'list-any-unit'))
            endPoint = endpoints[plan].holding;
        if(verifyPermission(userPermissions,'list-my-unit'))
            endPoint = endpoints[plan].filial;
        break;
    default:
        endPoint = endpoints[plan];
        break;
  }
  return endPoint;
};

export const fetchUers = async (endPoint,page, perPage = 10, search = '') => {
  try {
    const response = await axios.get(endPoint.list(page,perPage,search));
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const enableDisableUser = async (endPoint, userId) => {
  try {
    const response = await axios.put(endPoint.enableDisable(userId));
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const logoutUser = async (endPoint, userId) => {
    try {
        const response = await axios.post(endPoint.logout, { id:userId });
        return response.data;
    } catch (error) {
        throw error;
    }
}
